import SolutionImageIcon from './SolutionImageIcon'

export default SolutionImageIcon
